/* src/app/modules/ct-status/components/cts-gantry-log-table/cts-gantry-log-table.component.scss */
:host {
  display: block;
  width: 100%;
}
.flex-row {
  display: flex;
  flex-flow: row nowrap;
}
.header-container {
  width: 100%;
  justify-content: space-between;
}
.header-title,
.header-action {
  gap: 0.5rem;
  align-items: center;
}
.header-title sh-icon,
.header-action sh-icon {
  color: rgb(var(--ui-5));
}
.header-action sh-input-text {
  width: 14rem;
}
.secondary-filters {
  justify-content: space-between;
  align-items: center;
}
.secondary-filters .checkbox-filters {
  gap: 1rem;
  align-items: center;
}
.secondary-filters .checkbox-filters sh-checkbox {
  white-space: nowrap;
}
.log-table {
  margin-top: 1rem;
  display: grid;
}
.icon-status {
  align-self: flex-start;
  margin-top: 0.2rem;
}
sh-table {
  max-height: 40rem;
}
sh-table sh-table-row:first-child {
  border-top: 0.0625rem solid rgba(0, 0, 0, 0.4);
}
.row--error {
  background: rgba(231, 0, 29, 0.05);
}
@media only screen and (max-width: 1380px) {
  .table-group__filter {
    position: inherit;
    top: inherit;
    margin-bottom: 0.25rem;
  }
}
@media only screen and (max-width: 1500px) {
  .header-container {
    flex-direction: column;
    gap: 0.8em;
  }
}
.table-header-action {
  gap: 0.6rem;
}
/*# sourceMappingURL=cts-gantry-log-table.component.css.map */
